import Splide from "@splidejs/splide";
import "@splidejs/splide/css/core";

// Load carousel for Gutenberg block acf/d7-carousel-recipes
export function loadD7CarouselRecipes() {
  const rangeCarousels = document.querySelectorAll(".carousel-splide-recipes");
  rangeCarousels.forEach(carousel => {
    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
    }

    let splide = new Splide(carousel, {
      perPage: 4,
      perMove: 1,
      gap: 32,
      width: "100%",
      pagination: false,
      breakpoints: {
        968: {
          gap: 32,
          perPage: 3,
        },
        640: {
          gap: 15,
          perPage: 2,
        },
      },
    })
      .on("overflow", function (isOverflow) {
        const arrowsDiv = document.querySelector(".splide__arrows");
        if (!isOverflow) {
          arrowsDiv.classList.add("hide-arrows");
        }
      })
      .mount();

    carousel.splideInstance = splide;
  });
}

// Load carousel for Gutenberg block acf/d9-carousel displaying ranges
export function loadD9CarouselRanges() {
  const rangeCarousels = document.querySelectorAll(".carousel-splide-range");
  rangeCarousels.forEach(carousel => {
    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
    }

    let splide = new Splide(carousel, {
      perMove: 1,
      gap: 32,
      pagination: false,
      breakpoints: {
        640: {
          gap: 15,
        },
      },
    })
      .on("overflow", function (isOverflow) {
        const arrowsDiv = document.querySelector(".splide__arrows");
        if (!isOverflow) {
          arrowsDiv.classList.add("hide-arrows");
        }
      })
      .mount();

    carousel.splideInstance = splide;
  });
}

// Load carousel for Gutenberg block acf/d9-carousel displaying wines
export function loadD9CarouselWines() {
  const rangeCarousels = document.querySelectorAll(".carousel-splide-wines");
  rangeCarousels.forEach(carousel => {
    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
    }

    let splide = new Splide(carousel, {
      perMove: 1,
      gap: 32,
      pagination: false,
      breakpoints: {
        640: {
          gap: 15,
        },
      },
    })
      .on("overflow", function (isOverflow) {
        const arrowsDiv = document.querySelector(".splide__arrows");
        if (!isOverflow) {
          arrowsDiv.classList.add("hide-arrows");
        }
      })
      .mount();

    carousel.splideInstance = splide;
  });
}

// Load carousel for Gutenberg block acf/d14-carousel-region-carousel
export function loadD14CarouselRegions() {
  const regionCarousels = document.querySelectorAll(".carousel-splide-region");
  regionCarousels.forEach(carousel => {
    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
    }

    let splide = new Splide(carousel, {
      type: "loop",
      gap: 32,
      pagination: false,
      breakpoints: {
        640: {
          gap: 15,
        },
      },
    })
      .on("overflow", function (isOverflow) {
        const arrowsDiv = document.querySelector(".splide__arrows");
        if (!isOverflow) {
          arrowsDiv.classList.add("hide-arrows");
        }
      })
      .mount();

    carousel.splideInstance = splide;
  });
}

// Load carousel for Gutenberg block acf/d15-carousel-insta-feed
export function loadD15Carousel() {
  const instaCarousels = document.querySelectorAll(".carousel-splide-instafeed");
  instaCarousels.forEach(carousel => {
    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
    }

    let splide = new Splide(carousel, {
      perPage: 3,
      perMove: 1,
      gap: 32,
      width: "100%",
      pagination: false,
      breakpoints: {
        968: {
          gap: 32,
          perPage: 3,
        },
        640: {
          gap: 15,
          perPage: 2,
        },
        480: {
          gap: 15,
          perPage: 1,
        },
      },
    })
      .on("overflow", function (isOverflow) {
        const arrowsDiv = document.querySelector(".splide__arrows");
        if (!isOverflow) {
          arrowsDiv.classList.add("hide-arrows");
        }
      })
      .mount();

    carousel.splideInstance = splide;
  });
}

// Load carousel for Gutenberg block acf/a10-full-bleed-image-carousel
export function loadA10Carousels() {
  const fullBleedCarousels = document.querySelectorAll(".carousel-splide-full-bleed");
  fullBleedCarousels.forEach(carousel => {
    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
    }

    let splide = new Splide(carousel, {
      type: "loop",
      gap: 0,
      pagination: false,
    })
      .on("overflow", function (isOverflow) {
        const arrowsDiv = document.querySelector(".splide__arrows");
        if (!isOverflow) {
          arrowsDiv.classList.add("hide-arrows");
        }
      })
      .mount();

    carousel.splideInstance = splide;
  });
}

// Initialize all carousels on front end
document.addEventListener("DOMContentLoaded", function () {
  let rangeCarousels = document.querySelectorAll(".carousel-splide-range");
  if (rangeCarousels !== undefined) {
    loadD9CarouselRanges();
  }
  let wineCarousels = document.querySelectorAll(".carousel-splide-wines");
  if (wineCarousels !== undefined) {
    loadD9CarouselWines();
  }
  if (document.getElementById("d15-carousel-insta-feed")) {
    loadD15Carousel();
  }
  let recipeCarousels = document.querySelectorAll(".carousel-splide-recipes");
  if (recipeCarousels !== undefined) {
    loadD7CarouselRecipes();
  }
  let regionCarousels = document.querySelectorAll(".carousel-splide-region");
  if (regionCarousels !== undefined) {
    loadD14CarouselRegions();
  }
  let fullBleedCarousels = document.querySelectorAll(".carousel-splide-full-bleed");
  if (fullBleedCarousels !== undefined) {
    loadA10Carousels();
  }
});
